import { useContext, useEffect, useState } from 'react';

import { API, api } from 'modules/api';
import { DashboardLoadedType, DashboardType } from '../types';
import { LoginTypeContext } from 'modules/context';
import { ResourceHubItemType } from 'components/FeaturedResources/types';
import logger from 'modules/logger';
import { InformationCard } from 'components/CMSModals/informationcard';

export const useKeyTemplates = (
  setLoaded: React.Dispatch<React.SetStateAction<DashboardLoadedType>>,
  dashboard?: DashboardType,
) => {
  const { loginTypeContext } = useContext(LoginTypeContext);
  const [keyTemplates, setKeyTemplates] = useState<InformationCard[]>();

  useEffect(() => {
    if (loginTypeContext) {
      //TODO done useEffect
      let active = true;
      (async () => {
        try {
          const contentQueryModel = {
            contentType: 'Home',
            contentTitle: 'Member Content - Articles',
            applicationKey: '2516792660796088484',
            environmentKey: '2516792660283373119',
          };

          console.log(contentQueryModel);

          api(
            API.GET_DASHBOARD_CONTENT_TYPES({
              contentQueryModel,
            }),
          ).then(response => {
            if (active) {
              setKeyTemplates(
                response.data.multipleObjectParentModels[0]
                  .informationCardModels,
              );
            }
          });
        } catch (error) {
          active && logger.error('Get Key Templates Error', error);
        } finally {
          active &&
            setLoaded(prevState => ({
              ...prevState,
              keyTemplates: true,
            }));
        }
      })();
      return () => {
        active = false;
      };
    }
  }, [dashboard, loginTypeContext, setLoaded]);

  return { keyTemplates };
};
